<div class="vendor-page audit-shell">
  <div class="vendor-shell p-3 p-lg-4 audit-header-card">
    <div class="d-flex flex-column flex-xl-row justify-content-between gap-3 align-items-xl-center audit-header">
      <div class="d-flex align-items-center gap-3 title-block">
        <span class="title-badge title-icon">
          <lucide-icon [img]="ClipboardListIcon" [size]="20"></lucide-icon>
        </span>
        <div>
          <h1 class="page-title-lite mb-0">Audit Log</h1>
          <p class="page-subtitle-lite mb-0">Track create, update, and delete activity with old and changed values.</p>
        </div>
      </div>
      <div class="d-flex gap-2 flex-wrap justify-content-xl-end align-items-center header-actions">
        <button class="btn btn-sm create-btn export" type="button" (click)="toggleFilters()">
          <lucide-icon [img]="FilterIcon" [size]="15"></lucide-icon>
          <span class="ms-2">{{ filtersOpen() ? 'HIDE FILTERS' : 'SHOW FILTERS' }}</span>
        </button>
        <button class="btn btn-sm create-btn primary" type="button" (click)="refresh()">
          <lucide-icon [img]="RefreshCwIcon" [size]="15"></lucide-icon>
          <span class="ms-2">REFRESH</span>
        </button>
      </div>
    </div>

    @if (filtersOpen()) {
      <div class="filters-card mt-3">
        <div class="filters-title">
          <lucide-icon [img]="FilterIcon" [size]="16"></lucide-icon>
          <span>Filters</span>
        </div>

        <div class="filters-grid">
          <div class="field">
            <label>Module</label>
            <select class="form-select" [value]="filters().moduleName" (change)="setFilter('moduleName', ($any($event.target).value || '').toString())">
              <option value="">All Modules</option>
              @for (item of moduleOptions(); track item) {
                <option [value]="item">{{ item }}</option>
              }
            </select>
          </div>

          <div class="field">
            <label>User</label>
            <select class="form-select" [value]="filters().userId" (change)="setFilter('userId', ($any($event.target).value || '').toString())">
              <option value="">All Users</option>
              @for (item of userOptions(); track item.id) {
                <option [value]="item.id">{{ item.label }}</option>
              }
            </select>
          </div>

          <div class="field">
            <label>Menu</label>
            <select class="form-select" [value]="filters().entityName" (change)="setFilter('entityName', ($any($event.target).value || '').toString())">
              <option value="">All Menus</option>
              @for (item of entityOptions(); track item) {
                <option [value]="item">{{ item }}</option>
              }
            </select>
          </div>

          <div class="field">
            <label>Action</label>
            <select class="form-select" [value]="filters().action" (change)="setFilter('action', ($any($event.target).value || '').toString())">
              <option value="">All Actions</option>
              @for (item of actionOptions(); track item) {
                <option [value]="item">{{ item }}</option>
              }
            </select>
          </div>

          <div class="field">
            <label>Date From</label>
            <input class="form-control" type="date" [value]="filters().dateFrom" (input)="setFilter('dateFrom', ($any($event.target).value || '').toString())" />
          </div>

          <div class="field">
            <label>Date To</label>
            <input class="form-control" type="date" [value]="filters().dateTo" (input)="setFilter('dateTo', ($any($event.target).value || '').toString())" />
          </div>

          <div class="field search-field">
            <label>Search</label>
            <div class="search-wrap">
              <input class="form-control search-input" placeholder="Search old/new values, action, entity" [value]="filters().search" (input)="setFilter('search', ($any($event.target).value || '').toString())" />
              <lucide-icon [img]="SearchIcon" [size]="16" class="search-icon"></lucide-icon>
            </div>
          </div>
        </div>

        <div class="filters-actions">
          <button class="secondary-btn" type="button" (click)="resetFilters()">Reset</button>
          <button class="primary-btn" type="button" (click)="applyFilters()">Apply</button>
        </div>
      </div>
      }
  </div>

  <div class="panel-card table-card p-3 p-lg-4">
      <div class="table-meta mb-3">
        @if (loading()) {
          <span>Loading...</span>
        }
      </div>

      <div class="table-wrap">
      <div class="table-responsive">
        <table class="table audit-table mb-0">
          <thead class="table-head">
            <tr>
              <th>S.No.</th>
              <th>When</th>
              <th>Module</th>
              <th>User</th>
              <th>Action</th>
              <th>Menu Name</th>
              <th>User Type</th>
              <th>Url</th>
              <th>Priority</th>
              <th>Menu List</th>
              <th>Parent</th>
              <th>Alias</th>
              <th>Icon</th>
              <th>Send Image</th>
              <th>Default</th>
              <th>Show</th>
              <th>Active</th>
              <th>Changes</th>
            </tr>
          </thead>
          <tbody>
            @if (!loading() && filteredRows().length === 0) {
              <tr>
                <td colspan="18" class="empty-state">No audit logs found for the selected filters.</td>
              </tr>
            }

            @for (row of pagedRows(); track row.id; let i = $index) {
              <tr>
                <td>{{ ((currentPage() - 1) * pageSize()) + i + 1 }}</td>
                <td>{{ row.created_at | date: 'dd-MMM-yyyy HH:mm' }}</td>
                <td>{{ row.module_name }}</td>
                <td>
                  <div class="user-cell">
                    <strong>{{ row.changed_by_name || '-' }}</strong>
                    <span>{{ row.changed_by_role || row.changed_by || '-' }}</span>
                  </div>
                </td>
                <td><span class="action-pill" [class.create]="row.action === 'CREATE'" [class.update]="row.action === 'UPDATE'" [class.delete]="row.action === 'DELETE'">{{ row.action }}</span></td>
                <td>{{ rowMenuName(row) }}</td>
                <td>{{ rowUserType(row) }}</td>
                <td>{{ rowMenuUrl(row) }}</td>
                <td>{{ rowMenuPriority(row) }}</td>
                <td>{{ rowMenuList(row) }}</td>
                <td>{{ rowParentLabel(row) }}</td>
                <td>{{ rowMenuAlias(row) }}</td>
                <td>{{ rowMenuIcon(row) }}</td>
                <td>{{ rowSendImage(row) }}</td>
                <td>{{ rowIsDefault(row) }}</td>
                <td>{{ rowIsShow(row) }}</td>
                <td>{{ rowIsActive(row) }}</td>
                <td>
                  <button class="link-btn" type="button" (click)="toggleExpand(row.id)">
                    {{ isExpanded(row.id) ? 'Hide' : 'View' }} details
                  </button>
                </td>
              </tr>
              @if (isExpanded(row.id)) {
                <tr class="detail-row">
                  <td colspan="18">
                    <div class="detail-grid">
                      <div class="detail-card">
                        <div class="detail-title">Old Data</div>
                        @if (oldKeys(row).length === 0) {
                          <div class="empty-detail">No previous values recorded.</div>
                        } @else {
                          @for (key of oldKeys(row); track key) {
                            <div class="detail-item" [class.detail-item-changed]="isChangedKey(row, key)">
                              <span class="detail-key">
                                {{ key }}
                                @if (isChangedKey(row, key)) {
                                  <span class="change-badge">Changed</span>
                                }
                              </span>
                              <pre>{{ (row.old_data || {})[key] | json }}</pre>
                            </div>
                          }
                        }
                      </div>

                      <div class="detail-card">
                        <div class="detail-title">Changed Data</div>
                        @if (newKeys(row).length === 0) {
                          <div class="empty-detail">No changed values recorded.</div>
                        } @else {
                          @for (key of newKeys(row); track key) {
                            <div class="detail-item" [class.detail-item-changed]="isChangedKey(row, key)">
                              <span class="detail-key">
                                {{ key }}
                                @if (isChangedKey(row, key)) {
                                  <span class="change-badge">Changed</span>
                                }
                              </span>
                              <pre>{{ (row.new_data || {})[key] | json }}</pre>
                            </div>
                          }
                        }
                      </div>
                    </div>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
      </div>

      @if (!loading()) {
        <div class="pager-row mt-3">
          <div class="pager-meta">{{ startRow() }}-{{ endRow() }} of {{ filteredRows().length }} logs</div>
          <div class="pagination-shell">
            <button class="pager-btn" [disabled]="currentPage() <= 1" (click)="setPage(1)" aria-label="First page">
              <lucide-icon [img]="ChevronsLeftIcon" [size]="14"></lucide-icon>
            </button>
            <button class="pager-btn" [disabled]="currentPage() <= 1" (click)="previousPage()" aria-label="Previous page">
              <lucide-icon [img]="ChevronLeftIcon" [size]="14"></lucide-icon>
            </button>
            <span class="page-indicator current">{{ currentPage() }}</span>
            <button class="pager-btn" [disabled]="currentPage() >= totalPages()" (click)="nextPage()" aria-label="Next page">
              <lucide-icon [img]="ChevronRightIcon" [size]="14"></lucide-icon>
            </button>
            <button class="pager-btn" [disabled]="currentPage() >= totalPages()" (click)="setPage(totalPages())" aria-label="Last page">
              <lucide-icon [img]="ChevronsRightIcon" [size]="14"></lucide-icon>
            </button>
            <select class="form-select form-select-sm page-size-select pager-size-select" [value]="pageSize()" (change)="setPageSize(($any($event.target).value || '10').toString())" aria-label="Rows per page">
              @for (size of pageSizes; track size) {
                <option [value]="size">{{ size }}/Page</option>
              }
            </select>
          </div>
        </div>
      }
  </div>
</div>
